import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { fetchApi } from "../../../helper/fetchApi";

//init type
interface intState {
    data: Array<any>;
    status: string;
}

//init state
const initialState: intState = {
    data: [],
    status: "init",
};

//get data
export const getHistDataAsync = createAsyncThunk(
    "/histState/getHistDataAsync",
    async (data: { data: any; access_token: string }, { rejectWithValue }) => {
        try {
            const response = await fetchApi("/hist/rows", data.data, data.access_token);
            return response;
        } catch (err: any) {
            return rejectWithValue(err.response.data);
        }
    }
);

//create slice obj
export const histSlice = createSlice({
    name: "histState",
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        initData: (state) => {
            state.data = initialState.data;
            state.status = initialState.status;
        },
    },
    extraReducers: (builder) => {
        builder
            //GET HISTORY
            .addCase(getHistDataAsync.pending, (state) => {
                state.status = "load";
            })
            .addCase(getHistDataAsync.fulfilled, (state, action) => {
                //success connection?
                try {
                    //success login?
                    if (action.payload.active) {
                        state.data = action.payload.data;
                        state.status = "success";
                    } else {
                        state.status = "unsuccess";
                    }
                } catch (err) {
                    state.status = "failed";
                    console.log("TypeError: JsonError when attempting resolve data.");
                }
            });
    },
});

//create actions obj
export const { setStatus, initData } = histSlice.actions;

//get data from store
export const selectData = (state: RootState) => state.histState.data;
export const selectStatus = (state: RootState) => state.histState.status;

//create reducer
export default histSlice.reducer;
